// const lenis = new Lenis({
//   duration: 1.2,
//   easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)), 
//   wheelMultiplier: 1,
//   autoResize: false, // Ensure this is on
// });

// function raf(time) {
//   lenis.raf(time);
//   requestAnimationFrame(raf);
// }

// requestAnimationFrame(raf);

// // 1. Fix for Shopify Section loads
// // document.addEventListener('shopify:section:load', () => {
// //   lenis.resize();
// // });

// // 2. Fix for late-loading images/fonts
// window.addEventListener('load', () => {
//   lenis.resize();
// });

// // 3. Constant watch for height changes (Best for footers)
// // new ResizeObserver(() => lenis.resize()).observe(document.body);

// const lenis = new Lenis({
//   allowNestedScroll: true,
// });

// // Use requestAnimationFrame to continuously update the scroll
// function raf(time) {
//   lenis.raf(time);
//   requestAnimationFrame(raf);
// }

// requestAnimationFrame(raf);

document.addEventListener('DOMContentLoaded', function () {
  const scrollers = document.querySelectorAll(".js-logo__container");

  if (scrollers.length > 0) addAnimation();

  function addAnimation() {
    scrollers.forEach((scroller) => {
      scroller.setAttribute("data-animated", true);
      const scrollerInner = scroller.querySelector(".logo__wrapper");
      const scrollerContent = Array.from(scrollerInner.children);
      scrollerContent.forEach((item) => {
        const duplicatedItem = item.cloneNode(true);
        duplicatedItem.setAttribute("aria-hidden", true);
        scrollerInner.appendChild(duplicatedItem);
      });
    });
  }

  const collectionCardEl = document.querySelector('.js-collection-carousel-swiper');

  if (collectionCardEl) {
    const collectionCardSwiper = new Swiper('.js-collection-carousel-swiper', {
      slidesPerView: 2,
      spaceBetween: 10,
      loop: true,
      navigation: {
        nextEl: ".collection-carousel__nav--next",
        prevEl: ".collection-carousel__nav--prev",
      },
      breakpoints: {
        768: {
          slidesPerView: 2
        },
        1024: {
          slidesPerView: 3
        },
        1440: {
          slidesPerView: 4
        }
      },
    });
  }

  const collectionCardEl2 = document.querySelector('.js-collection-carousel-swiper2');

  if (collectionCardEl2) {
    const collectionCardSwiper2 = new Swiper('.js-collection-carousel-swiper2', {
      slidesPerView: 2,
      spaceBetween: 10,
      navigation: {
        nextEl: ".collection-carousel__nav--next",
        prevEl: ".collection-carousel__nav--prev",
      },
      breakpoints: {
        768: {
          slidesPerView: 2
        },
        1024: {
          slidesPerView: 3
        },
        1440: {
          slidesPerView: 4
        }
      },
    });
  }

  const accordionSlider = document.querySelector('.js-accordion-slider-swiper');

  if (accordionSlider) {
    const isStatic = accordionSlider.classList.contains('accordion-slider__swiper--static');
    const collectionCardSwiper = new Swiper('.js-accordion-slider-swiper', {
      slidesPerView: 1,
      spaceBetween: 10,
      allowTouchMove: false,
    });

    const accordionHeaders = document.querySelectorAll('.accordion-header');

    accordionHeaders.forEach(header => {
      if (isStatic) return;
      header.addEventListener('click', function () {
        const slideIndex = parseInt(this.dataset.slideIndex, 10);

        if (!isNaN(slideIndex)) {
          collectionCardSwiper.slideTo(slideIndex);
        }
      });
    });
  }

  const accordionHeaders = document.querySelectorAll('.accordion-slider__accordion .accordion-header');

  if (accordionHeaders) {
    accordionHeaders.forEach(header => {
      header.addEventListener('click', function () {

        if (window.innerWidth > 768) return;

        const accordionItem = this.closest('.accordion');
        const accordionContent = accordionItem.querySelector('.accordion-content');

        // Only scroll when opening
        setTimeout(() => {
          if (!accordionItem.classList.contains('active')) return;

          // Wait for height transition to finish
          const onTransitionEnd = () => {
            accordionContent.removeEventListener('transitionend', onTransitionEnd)

            // 🔥 Then scroll
            const headerEl = document.querySelector('.section-header'); // adjust selector
            const headerHeight = headerEl ? headerEl.offsetHeight : 0;

            const targetPosition = header.getBoundingClientRect().top + window.scrollY;

            // lenis.scrollTo(accordionItem, {
            //   offset: -headerHeight,
            //   duration: 1.2
            // });

            window.scrollTo({
              top: targetPosition - headerHeight - 10,
              behavior: "smooth",
            });
            
          };

          accordionContent.addEventListener('transitionend', onTransitionEnd);

        }, 50);

      });
    });
  }

  const galleryEl = document.querySelector('.js-gallery-custom-swiper');

  if (galleryEl) {
    const gallerySwiper = new Swiper('.js-gallery-custom-swiper', {
      slidesPerView: 1,
      spaceBetween: 10,
      loop: true,
      navigation: {
        nextEl: ".gallery-custom-swiper--mobile--nav--next",
        prevEl: ".gallery-custom-swiper--mobile--nav--prev",
      },
    });
  }

  const productCardEl = document.querySelector('.js-featured-product-custom-swiper');

  if (productCardEl) {
    const productCardSwiper = new Swiper('.js-featured-product-custom-swiper', {
      slidesPerView: 1,
      loop: true,
      spaceBetween: 10,
      navigation: {
        nextEl: ".featured-product-custom__nav--next",
        prevEl: ".featured-product-custom__nav--prev",
      },
      breakpoints: {
        768: {
          slidesPerView: 2,
          spaceBetween: 20,
          slidesOffsetAfter: 50
        },
        1024: {
          slidesPerView: 2,
          spaceBetween: 24,
          slidesOffsetAfter: 105
        },
        1440: {
          slidesPerView: 2,
          spaceBetween: 32,
          slidesOffsetAfter: 210
        }
      }
    });
  }

  const productCardEl2 = document.querySelector('.js-featured-product-custom-swiper2');

  if (productCardEl2) {
    const productCardSwiper2 = new Swiper('.js-featured-product-custom-swiper2', {
      slidesPerView: 1,
      loop: true,
      spaceBetween: 10,
      navigation: {
        nextEl: ".featured-product-custom__nav--next",
        prevEl: ".featured-product-custom__nav--prev",
      },
      breakpoints: {
        768: {
          slidesPerView: 2,
          spaceBetween: 20,
          slidesOffsetAfter: 50
        },
        1024: {
          slidesPerView: 2,
          spaceBetween: 24,
          slidesOffsetAfter: 105
        },
        1440: {
          slidesPerView: 2,
          spaceBetween: 32,
          slidesOffsetAfter: 210
        }
      }
    });
  }

  const relatedProductCardEl = document.querySelector('.js-related-products-custom-swiper');

  if (relatedProductCardEl) {
    const relatedProductCardSwiper = new Swiper('.js-related-products-custom-swiper', {
      slidesPerView: 1,
      loop: false,
      spaceBetween: 10,
      navigation: {
        nextEl: ".featured-product-custom__nav--next",
        prevEl: ".featured-product-custom__nav--prev",
      },
      breakpoints: {
        768: {
          slidesPerView: 2,
          slidesOffsetAfter: 50,
        },
        1024: {
          slidesPerView: 2,
          spaceBetween: 24,
          slidesOffsetAfter: 105,
        },
        1440: {
          slidesPerView: 2,
          spaceBetween: 32,
          slidesOffsetAfter: 210,
        }
      },
    });
  }

  const relatedProductCardEl2 = document.querySelector('.js-related-products-custom-swiper2');

  if (relatedProductCardEl2) {
    const relatedProductCardSwiper2 = new Swiper('.js-related-products-custom-swiper2', {
      slidesPerView: 1,
      loop: false,
      spaceBetween: 10,
      navigation: {
        nextEl: ".featured-product-custom__nav--next",
        prevEl: ".featured-product-custom__nav--prev",
      },
      breakpoints: {
        768: {
          slidesPerView: 2,
          slidesOffsetAfter: 50,
        },
        1024: {
          slidesPerView: 2,
          spaceBetween: 24,
          slidesOffsetAfter: 105,
        },
        1440: {
          slidesPerView: 2,
          spaceBetween: 32,
          slidesOffsetAfter: 210,
        }
      },
    });
  }

  const testimonialSwiperEl = document.querySelector('.js-testimonial-custom-swiper');

  if (testimonialSwiperEl) {
    const testimonialSwiper = new Swiper('.js-testimonial-custom-swiper', {
      slidesPerView: 1,
      spaceBetween: 10,
      slidesOffsetBefore: 20,
      slidesOffsetAfter: 20,
      loop: true,
      loopAdditionalSlides: 3,
      autoplay: {
        delay: 1500, 
        disableOnInteraction: false, 
        pauseOnMouseEnter: true, 
      },
      navigation: {
        nextEl: ".testimonial-custom__nav--next",
        prevEl: ".testimonial-custom__nav--prev",
      },
      breakpoints: {
        768: {
          slidesPerView: 2,
          spaceBetween: 16,
          slidesOffsetBefore: 20,
        slidesOffsetAfter: 20,
        },
        1024: {
          slidesPerView: 2,
          spaceBetween: 24,
          slidesOffsetBefore: 20,
        slidesOffsetAfter: 20,
        },
        1440: {
          slidesPerView: 2,
          spaceBetween: 32,
          slidesOffsetBefore: 20,
          slidesOffsetAfter: 20,
        },
        1441: {
          slidesPerView: 3,
          spaceBetween: 32,
          slidesOffsetBefore: 20,
          slidesOffsetAfter: 20,
        }
      }
    });
  }

  const feedCustomEl = document.querySelector('.js-feed-custom-swiper');

  if (feedCustomEl) {
    const feedCustomSwiper = new Swiper('.js-feed-custom-swiper', {
      slidesPerView: 2,
      spaceBetween: 10,
      breakpoints: {
        768: {
          slidesPerView: 2,
          spaceBetween: 16,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 24,
        },
        1440: {
          slidesPerView: 4,
          spaceBetween: 32,
        }
      },
    });
  }

  const videoMulticolumnEl = document.querySelector('.js-video-multicolumn-swiper');

  if (videoMulticolumnEl) {
    const videoMulticolumnSwiper = new Swiper('.js-video-multicolumn-swiper', {
      slidesPerView: 2.5,
      loop: true,
      spaceBetween: 10,
      autoplay: {
        delay: 1500, 
        disableOnInteraction: false, 
        pauseOnMouseEnter: true, 
      },
      breakpoints: {
        768: {
          slidesPerView: 3,
          spaceBetween: 16,
        },
        1024: {
          slidesPerView: 4,
          spaceBetween: 24,
        },
        1440: {
          slidesPerView: 6,
          spaceBetween: 24,
        }
      },
    });
  }

  const productMediaGallery = document.querySelector('.js-product-media-swiper');

  if (productMediaGallery) {
    const productMediaGalleryThumbSwiper = new Swiper('.js-product-media-thumb-swiper', {
      slidesPerView: 4,
      spaceBetween: 8,
      watchSlidesProgress: true,
    });
    const productMediaGallerySwiper = new Swiper('.js-product-media-swiper', {
      slidesPerView: 1,
      spaceBetween: 8,
      navigation: {
        nextEl: ".product-media__nav--next",
        prevEl: ".product-media__nav--prev",
      },
      thumbs: {
        swiper: productMediaGalleryThumbSwiper,
      },
    });
  }

  // Star Rating
  const starRating = document.querySelectorAll('.star-rating');
  
  if (starRating.length > 0) {
    starRating.forEach(container => {
      const rating = parseFloat(container.dataset.rating) || 0;

      for (let i = 1; i <= 5; i++) {
        const star = document.createElement('div');
        star.className = 'star';

        const inner = document.createElement('div');
        inner.className = 'star-inner';

        const fill = Math.max(0, Math.min(1, rating - (i - 1))) * 100;
        inner.style.width = fill + '%';

        star.appendChild(inner);
        container.appendChild(star);
      }
    });
  }

  // const popup = document.getElementById("video-popup");

  // if (popup) {
  //   const popupInner = popup.querySelector(".video-popup__inner");
  //   const marqueeInner = document.querySelector(".social-marquee__inner");

  //   document.addEventListener("click", function (event) {
  //     // Open popup
  //     // const playBtn = event.target.closest(".video-play-btn");

  //     const wrapper = event.target.closest(".video__wrapper");
  //     if (wrapper) {
  //       const videoHtml = playBtn.getAttribute("data-video-html");

  //       popupInner.innerHTML = videoHtml;
  //       popup.classList.add("active");

  //       marqueeInner?.classList.add("paused");
  //       return;
  //     }

  //     // Close popup
  //     if (
  //       event.target.closest(".video-popup__close") ||
  //       event.target.closest(".video-popup__overlay")
  //     ) {
  //       popup.classList.remove("active");
  //       popupInner.innerHTML = "";

  //       marqueeInner?.classList.remove("paused");
  //     }
  //   });
  // }

  document.addEventListener('click', function (e) {
    const playButton = e.target.closest('.play-button');
    if (!playButton) return;

    const wrapper = playButton.closest('[data-video]');
    const video = wrapper.querySelector('video, iframe');

    wrapper.classList.add('is-playing');

    if (video.tagName === 'VIDEO') {
      video.muted = false;
      video.currentTime = 0;
      video.play();
    }

    if (video.tagName === 'IFRAME') {
      const src = video.getAttribute('src');

      if (src.includes('youtube')) {
        video.src = src.replace('mute=1', 'mute=0') + '&autoplay=1';
      }

      if (src.includes('vimeo')) {
        video.src = src.replace('muted=1', 'muted=0') + '&autoplay=1';
      }
    }
  });

  const popup = document.getElementById("video-popup");

  if (popup) {
    const popupInner = popup.querySelector(".video-popup__inner");
    const marqueeInner = document.querySelector(".social-marquee__inner");

    document.addEventListener("click", function (event) {
      // Open popup when clicking wrapper
      const wrapper = event.target.closest(".video__wrapper");
      if (wrapper) {
        const playBtn = wrapper.querySelector(".video-play-btn");
        if (!playBtn) return;

        const videoHtml = playBtn.getAttribute("data-video-html");

        popupInner.innerHTML = videoHtml;
        popup.classList.add("active");

        marqueeInner?.classList.add("paused");
        return;
      }

      // Close popup
      if (
        event.target.closest(".video-popup__close") ||
        event.target.closest(".video-popup__overlay")
      ) {
        popup.classList.remove("active");
        popupInner.innerHTML = "";

        marqueeInner?.classList.remove("paused");
      }
    });
  }

  const inlineMenu = document.querySelector(".header__inline-menu");
  if (inlineMenu) {
    const detailsItems = inlineMenu.querySelectorAll("details");

    detailsItems.forEach(item => {
      const ulElement = item.querySelector("ul");
      item.addEventListener("mouseover", () => {
        item.setAttribute("open", true);

        ulElement.addEventListener("mouseleave", () => {
          item.removeAttribute("open");
        });

        item.addEventListener("mouseleave", () => {
          item.removeAttribute("open");
        });
      });
    });
  }

  // 1. Select ALL tab button containers
  const allTabContainers = document.querySelectorAll(".js-inner-tab--buttons");

  allTabContainers.forEach((tabContainer) => {
    // 2. Find the specific content container related to THIS tab container
    // We look inside the parent of the current tabContainer to find the content
    const contentContainer = tabContainer.parentElement.querySelector(".inner-tab-content");

    // Only proceed if both the buttons and the content exist for this instance
    if (tabContainer && contentContainer) {
      tabContainer.addEventListener("click", (e) => {
        // 3. Find if the clicked element (or its parent) is a tab button
        const clickedTab = e.target.closest("[data-inner-tab]");

        // If we didn't click a tab, do nothing
        if (!clickedTab) return;

        const targetId = clickedTab.dataset.innerTab;

        // 4. Remove 'active' class from all buttons IN THIS SPECIFIC container only
        tabContainer.querySelectorAll("[data-inner-tab].active")
          .forEach((tab) => tab.classList.remove("active"));

        // 5. Remove 'active' class from all content panes IN THIS SPECIFIC content container only
        contentContainer.querySelectorAll("[data-inner-tab].active")
          .forEach((content) => content.classList.remove("active"));

        // 6. Add 'active' class to the clicked button and its corresponding content
        clickedTab.classList.add("active");
        const targetContent = contentContainer.querySelector(`[data-inner-tab="${targetId}"]`);
        
        if (targetContent) {
          targetContent.classList.add("active");
        }
      });
    }
  });

  gsap.registerPlugin(SplitText);

  // Function to animate a single <em> element
  function createEmAnimation(em) {
    // Skip if already animated
    if (em.dataset.animated) return;
    
    // Mark as animated
    em.dataset.animated = 'true';

    const originalText = em.textContent.trim();

    const heading = em.closest('h1, h2, h3, h4, h5, h6');
    if (heading && !heading.hasAttribute('aria-label')) {
      heading.setAttribute('aria-label', originalText);
    }
    
    // Create clipping container
    const clipContainer = document.createElement('span');
    clipContainer.style.cssText = `
      display: inline;
      position: relative;
      overflow: hidden;
      padding-right: 0.8rem;
    `;
    
    // Wrap the <em> tag
    em.parentNode.insertBefore(clipContainer, em);
    clipContainer.appendChild(em);
    
    // Split text into characters
    const split = new SplitText(em, {
      type: "chars",
      smartWrap: true
    });
    
    // Initially hide characters below
    gsap.set(split.chars, {
      y: "300%"
    });
    
    // Create the animation timeline (PAUSED initially)
    const tl = gsap.timeline({
      paused: true,
      onComplete: () => {
        // Optional cleanup
        // split.revert();
      }
    });
    
    // Add the slide-up animation
    tl.to(split.chars, {
      y: "0%",
      duration: 0.6,
      stagger: 0.05,
      ease: "power2.out",
      delay: 0.3
    });
    
    // Store the animation on the element
    em._animation = tl;
    em._split = split;
    
    return tl;
  }

  // Initialize all animations when page loads
  function initAnimations() {
    // Find all <em> elements inside .slide-up containers
    const emElements = document.querySelectorAll('.slide-up em');
    
    emElements.forEach(em => {
      createEmAnimation(em);
    });
    
    // Check if any are already triggered (if at top of page)
    checkAndPlayTriggered();
  }

  // Function to check and play animations for triggered elements
  function checkAndPlayTriggered() {
    document.querySelectorAll('.slide-up.triggered').forEach(slideUp => {
      const emElements = slideUp.querySelectorAll('em');
      
      emElements.forEach(em => {
        if (em._animation && !em._animation.isActive()) {
          em._animation.play();
        }
      });
    });
  }

  // Observer to watch for .triggered class being added
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
        const element = mutation.target;
        
        // Check if it's a .slide-up element that just got .triggered class
        if (element.classList.contains('slide-up') && 
            element.classList.contains('triggered')) {
          
          // Find all <em> inside and play their animations
          const emElements = element.querySelectorAll('em');
          
          emElements.forEach(em => {
            // Create animation if it doesn't exist yet
            if (!em._animation) {
              createEmAnimation(em);
            }
            
            // Play the animation if not already playing
            if (em._animation && !em._animation.isActive()) {
              em._animation.play();
            }
          });
        }
      }
    });
  });

  // Start observing all .slide-up elements
  document.querySelectorAll('.slide-up').forEach(slideUp => {
    observer.observe(slideUp, { 
      attributes: true,
      attributeFilter: ['class']
    });
  });

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initAnimations();
    });
  } else {
    initAnimations();
  }

  // Optional: Also check on scroll for safety
  window.addEventListener('scroll', () => {
    checkAndPlayTriggered();
  });

  // const tabs = document.querySelectorAll('.media-with-text-tab-header-tab[data-tab]');
  // const panels = document.querySelectorAll('.media-with-text-tab-panel');
  // const tabTitles = document.querySelectorAll('.media-with-text__heading[data-tab-title-toggle]');

  // const tabs = document.querySelectorAll('.custom-tab-tab__header-tab[data-tab]');
  // const panels = document.querySelectorAll('.custom-tab__tab-panel');

  // if (tabs.length > 0) {

  //   function scrollToTarget(triggerElement) {
  //     const isMobile = window.innerWidth <= 768;
  //     let target;

  //     if (isMobile) {
  //       target = document.querySelector('.media-with-text-tab__dropdown');
  //     } else {
  //       target = document.querySelector('.media-with-text-tab__content');
  //     }


  //     if (!target) return;

  //     // Get dynamic header height
  //     const header = document.querySelector('.section-header'); // adjust if needed
  //     const headerHeight = header ? header.getBoundingClientRect().height : 0;

  //     const targetEl = document.querySelector(".media-with-text-tab__wrapper"); // adjust
  //     const targetPosition = targetEl.getBoundingClientRect().top + window.scrollY;

  //     // lenis.scrollTo(target, {
  //     //   offset: -headerHeight - 10,
  //     //   duration: 1.2
  //     // });
  //     window.scrollTo({
  //       top: targetPosition - headerHeight - 10,
  //       behavior: "smooth",
  //     });
  //   }

  //   tabs.forEach(tab => {
  //     tab.addEventListener('click', function () {
  //       const tabIndex = this.getAttribute('data-tab');
  //       const tabTitle = this.getAttribute('data-tab-title');

  //       // Update tabs
  //       tabs.forEach(t => {
  //         t.classList.remove('active');
  //         t.setAttribute('aria-selected', 'false');
  //       });
  //       this.classList.add('active');
  //       this.setAttribute('aria-selected', 'true');

  //       // Update panels
  //       panels.forEach((panel, index) => {
  //         if (index == tabIndex) {
  //           panel.classList.add('active');
  //           panel.removeAttribute('hidden');
            
  //         } else {
  //           panel.classList.remove('active');
  //           panel.setAttribute('hidden', '');
  //           panel.querySelector('.content__wrapper')?.classList.remove('triggered');
  //           panel.querySelector('.media__wrapper')?.classList.remove('triggered');
  //         }
  //       });

  //       tabTitles.forEach((title, index) => {

  //         if (title.getAttribute('data-tab-title-toggle') == tabTitle) {
  //           title.classList.add('active');
  //           title.removeAttribute('hidden');
  //         } else {
  //           title.classList.remove('active');
  //           title.setAttribute('hidden', '');
  //         }
  //       });

  //       scrollToTarget(this); // <<< pass the clicked tab
  //     });

  //     // Keyboard navigation
  //     tab.addEventListener('keydown', function (e) {
  //       if (e.key === 'Enter' || e.key === ' ') {
  //         e.preventDefault();
  //         this.click();
  //       }

  //       if (e.key === 'ArrowRight') {
  //         e.preventDefault();
  //         const nextTab = this.nextElementSibling || tabs[0];
  //         nextTab.focus();
  //         nextTab.click();
  //       }

  //       if (e.key === 'ArrowLeft') {
  //         e.preventDefault();
  //         const prevTab = this.previousElementSibling || tabs[tabs.length - 1];
  //         prevTab.focus();
  //         prevTab.click();
  //       }
  //     });
  //   });
  // }

  // const dropdown = document.querySelector('.media-with-text-tab-select');

  // if (dropdown) {
  //   dropdown.addEventListener('change', function () {
  //     const tabIndex = this.value;

  //     // Trigger the same logic as tabs
  //     if (tabs[tabIndex]) {
  //       tabs[tabIndex].click();
  //     }
  //   });
  // }

  // const dropdown2 = document.querySelector('.table-with-tab-select');

  // if (dropdown2) {
  //   dropdown2.addEventListener('change', function () {
  //     const tabIndex = this.value;

  //     // Trigger the same logic as tabs
  //     if (tabs[tabIndex]) {
  //       tabs[tabIndex].click();
  //     }
  //   });
  // }

  const tabWidgets = document.querySelectorAll(
    '.media-with-text-tab__container, .product-description-tab, .table-with-tab__container'
  );

  tabWidgets.forEach((widget) => {
    const tabTitles = widget.querySelectorAll(
      '.media-with-text__heading[data-tab-title-toggle]'
    );

    const tabs = widget.querySelectorAll(
      '.custom-tab-tab__header-tab[data-tab]'
    );

    const panels = widget.querySelectorAll(
      '.custom-tab__tab-panel'
    );

    if (!tabs.length || !panels.length) return;

    function scrollToTarget() {
      const isMobile = window.innerWidth <= 768;

      const target = isMobile
        ? widget.querySelector(
            '.media-with-text-tab__dropdown, .table-with-tab__dropdown'
          )
        : widget.querySelector(
            '.media-with-text-tab__content, .table-with-tab__content'
          );

      if (!target) return;

      const header = document.querySelector('.section-header');
      const headerHeight = header
        ? header.getBoundingClientRect().height
        : 0;

      const targetEl =
        widget.querySelector(
          '.media-with-text-tab__wrapper, .table-with-tab__wrapper'
        ) || widget;

      const targetPosition =
        targetEl.getBoundingClientRect().top + window.scrollY;

      window.scrollTo({
        top: targetPosition - headerHeight - 10,
        behavior: 'smooth'
      });
    }

    tabs.forEach((tab) => {
      tab.addEventListener('click', function () {
        const tabIndex = this.getAttribute('data-tab');
        const tabTitle = this.getAttribute('data-tab-title');

        tabs.forEach((t) => {
          t.classList.remove('active');
          t.setAttribute('aria-selected', 'false');
        });

        this.classList.add('active');
        this.setAttribute('aria-selected', 'true');

        panels.forEach((panel, index) => {
          if (index == tabIndex) {
            panel.classList.add('active');
            panel.removeAttribute('hidden');

            panel
              .querySelectorAll(
                '.fade-in, .slide-up, .slide-down, .slide-left, .slide-right, .zoom-in, .zoom-out, .scale-up, .rotate-in, .bounce-in, .image-animation'
              )
              .forEach((element) => {
                element.classList.add('triggered');
              });
          } else {
            panel.classList.remove('active');
            panel.setAttribute('hidden', '');
          }
        });

        tabTitles.forEach((title) => {
          if (
            title.getAttribute('data-tab-title-toggle') == tabTitle
          ) {
            title.classList.add('active');
            title.removeAttribute('hidden');
          } else {
            title.classList.remove('active');
            title.setAttribute('hidden', '');
          }
        });

        scrollToTarget();
      });

      tab.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          this.click();
        }

        if (e.key === 'ArrowRight') {
          e.preventDefault();

          const nextTab =
            this.nextElementSibling || tabs[0];

          nextTab.focus();
          nextTab.click();
        }

        if (e.key === 'ArrowLeft') {
          e.preventDefault();

          const prevTab =
            this.previousElementSibling ||
            tabs[tabs.length - 1];

          prevTab.focus();
          prevTab.click();
        }
      });
    });

    const dropdown = widget.querySelector(
      '.media-with-text-tab-select'
    );

    if (dropdown) {
      dropdown.addEventListener('change', function () {
        if (tabs[this.value]) {
          tabs[this.value].click();
        }
      });
    }

    const dropdown2 = widget.querySelector(
      '.table-with-tab-select'
    );

    if (dropdown2) {
      dropdown2.addEventListener('change', function () {
        if (tabs[this.value]) {
          tabs[this.value].click();
        }
      });
    }
  });

  // Phone input mask (US format: (XXX) XXX-XXXX)
  const phoneInputs = document.querySelectorAll('input[type="tel"]');

  if (phoneInputs) {
    phoneInputs.forEach(phoneInput => {
      phoneInput.addEventListener('input', function(e) {
        const x = phoneInput.value.replace(/\D/g, '').substring(0,10);
        
        if (x.length === 0) {
          phoneInput.value = '';
          return;
        }
        
        // Build the formatted string with underscores for missing digits
        const template = '(___) ___-____';
        const chars = x.split('');
        const positions = [1, 2, 3, 6, 7, 8, 10, 11, 12, 13]; // positions where digits go
        const result = template.split('');
        
        for (let i = 0; i < chars.length && i < positions.length; i++) {
          result[positions[i]] = chars[i];
        }
        
        phoneInput.value = result.join('');
        
        // Set cursor position
        let cursorPos = 1;
        if (chars.length > 0) cursorPos = positions[Math.min(chars.length - 1, positions.length - 1)] + 1;
        if (chars.length >= 3 && cursorPos <= 4) cursorPos = 6;
        if (chars.length >= 6 && cursorPos <= 9) cursorPos = 10;
        
        phoneInput.setSelectionRange(cursorPos, cursorPos);
      });

      phoneInput.addEventListener('keydown', function(e) {
        // Handle backspace
        if (e.key === 'Backspace') {
          e.preventDefault();
          let x = phoneInput.value.replace(/\D/g, '');
          if (x.length > 0) {
            x = x.substring(0, x.length - 1);
            if (x.length === 0) {
              phoneInput.value = '';
            } else {
              // Trigger input event to reformat
              var inputEvent = new Event('input', { bubbles: true });
              phoneInput.value = x;
              phoneInput.dispatchEvent(inputEvent);
            }
          }
        }
      });
    });
    
  }

  initVentDesignSwipers();
  observeProductGrid();

  const professionSelect = document.getElementById('ContactForm-profession');
  const otherContainer = document.getElementById('ContactForm-OtherField');
  const otherInput = document.getElementById('ContactForm-OtherInputField');

  if (professionSelect) {
    professionSelect.addEventListener('change', function() {
      if (this.value === 'Other') {
        // 1. Show the container
        otherContainer.style.display = 'block';
        // 2. Make the input required
        otherInput.setAttribute('required', 'required');
      } else {
        // 1. Hide the container
        otherContainer.style.display = 'none';
        // 2. Remove the required attribute
        otherInput.removeAttribute('required');
        // 3. Clear the input value (so "Other" data isn't sent if they change their mind)
        otherInput.value = '';
      }
    });
  }

  const professionSelectMobile = document.getElementById('ContactForm-profession--mobile');
  const otherContainerMobile = document.getElementById('ContactForm-OtherField--mobile');
  const otherInputMobile = document.getElementById('ContactForm-OtherInputField--mobile');

  if (professionSelectMobile) {
    professionSelectMobile.addEventListener('change', function() {
      if (this.value === 'Other') {
        // 1. Show the container
        otherContainerMobile.style.display = 'block';
        // 2. Make the input required
        otherInputMobile.setAttribute('required', 'required');
      } else {
        // 1. Hide the container
        otherContainerMobile.style.display = 'none';
        // 2. Remove the required attribute
        otherInputMobile.removeAttribute('required');
        // 3. Clear the input value (so "Other" data isn't sent if they change their mind)
        otherInputMobile.value = '';
      }
    });
  }

});

let ventDesignSwipers = new WeakMap();

function toggleNavigation(swiper) {
  const totalSlides = swiper.slides.length;
  const currentSlidesPerView = swiper.params.slidesPerView;

  if (totalSlides <= currentSlidesPerView) {
    swiper.navigation.disable();
  } else {
    swiper.navigation.enable();
  }
}

function initVentDesignSwipers(root = document) {
  const elements = root.querySelectorAll('.js-vent-design-swiper');

  elements.forEach((el) => {
    // Already initialized
    if (el.classList.contains('swiper-initialized')) return;

    const swiper = new Swiper(el, {
      slidesPerView: 1,
      spaceBetween: 10,
      watchOverflow: true,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      breakpoints: {
        768: {
          slidesPerView: 1,
          slidesOffsetAfter: 50,
        },
        1024: {
          slidesPerView: 2,
          spaceBetween: 24,
          slidesOffsetAfter: 0,
        },
        1440: {
          slidesPerView: 2,
          spaceBetween: 32,
          slidesOffsetAfter: 210,
        }
      },
      on: {
        init(swiper) {
          toggleNavigation(swiper);
        },
        breakpoint(swiper) {
          toggleNavigation(swiper);
        },
        resize(swiper) {
          toggleNavigation(swiper);
        }
      }
    });

    ventDesignSwipers.set(el, swiper);
  });
}

function observeProductGrid() {
  const container = document.getElementById('ProductGridContainer');
  if (!container) return;

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      if (mutation.type !== 'childList') continue;

      mutation.addedNodes.forEach((node) => {
        if (!(node instanceof HTMLElement)) return;

        // If a swiper was added directly
        if (node.classList?.contains('js-vent-design-swiper')) {
          initVentDesignSwipers(node.parentElement);
        }

        // Or nested inside new HTML
        if (node.querySelector?.('.js-vent-design-swiper')) {
          initVentDesignSwipers(node);
        }
      });
    }
  });

  observer.observe(container, {
    childList: true,
    subtree: true,
  });
}